export default {
    SET_PROPERTY_DETAILS(state, payload) {
        state.property = payload;
    },
    SET_CURRENCY(state, payload){
      state.property.currency = payload
    },
}
